import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { LANGUAGES, translations } from "@/i18n/translations";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("dc_lang") : null;
    return saved && LANGUAGES[saved] ? saved : "en";
  });

  useEffect(() => {
    const dir = LANGUAGES[lang].dir;
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);
    document.body.classList.toggle("font-ar", lang === "ar");
    document.body.classList.toggle("font-zh", lang === "zh");
    localStorage.setItem("dc_lang", lang);
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang],
      dir: LANGUAGES[lang].dir,
      languages: LANGUAGES,
    }),
    [lang]
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
};
